<script lang="ts">
  import BreadcrumbNavigation from "@retailer/svelte/BreadcrumbNavigation/BreadcrumbNavigation.svelte";
  import DistributorHeader from "@retailer/svelte/ProductLines/Index/DistributorHeader.svelte";
  import ProductLinesContainer from "@retailer/svelte/ProductLines/ProductLineContainer/ProductLinesContainer.svelte";
  import DistributorsStore from "@shared/svelte/Stores/DistributorsStore";
  import { params } from "@roxi/routify";
  import type { Distributor } from "@shared/types/Distributor";
  import LayoutStore from "@shared/svelte/Stores/LayoutStore";
  import PageWrapper from "@retailer/svelte/Shared/PageWrapper.svelte";
  import { getControlStateAuthenticationService } from "@retailer/services/retailer_user_authentications_service";
  import RetailerUserAuthenticationsStore from "@retailer/svelte/stores/RetailerUserAuthenticationsStore";

  let authService = getControlStateAuthenticationService();

  export let discoveryPanelRes;
  export let Cart;
  export let productIndexBannersRes;
  export let shoppableUnitRes = {};
  export let stateParams;

  let distributorOrTagHeader: boolean = false;
  let isDistributorPlp: boolean = false;

  $: {
    stateParams = stateParams;
    isDistributorPlp = stateParams.distributors?.length > 0;
    distributorOrTagHeader = isDistributorPlp || stateParams.tagId;
  }

  let distributor: Distributor;

  $: distributor = $DistributorsStore.find(d => d.id == $params.distributors?.[0]) || {};

  $: hideAllDistributorInfo = authService?.shouldHideAllDistributorInfo?.(
    $RetailerUserAuthenticationsStore,
    [distributor.id],
  );
  $: authStatus = authService?.getRetailerUserAuthenticationStatus?.(
    $RetailerUserAuthenticationsStore,
    [distributor.id],
  );

  $: outerBreadcrumbClasses = distributorOrTagHeader
    ? "fizz-inset-vertical-24 margin-container"
    : "fizz-surface-gray";
  $: innerBreadcrumbClasses = distributorOrTagHeader
    ? "fizz-flex-row fizz-stack-16"
    : "fizz-inset-vertical-24 margin-container";
  $: headerTestId = distributorOrTagHeader ? "distributor-tag-header" : "standard-plp-header";
</script>

<style>
  .blue-header {
    background: linear-gradient(#f2f7fb 65%, transparent 65%);
  }
</style>

<PageWrapper let:mobileMode>
  <div class="fizz-styles">
    <div class:blue-header={isDistributorPlp}>
      <div class={outerBreadcrumbClasses} data-testid={headerTestId}>
        <div
          class={innerBreadcrumbClasses}
          class:fizz-stack-32={isDistributorPlp && $LayoutStore.isDesktop}
        >
          <BreadcrumbNavigation overridePageTitle={true} />
        </div>

        {#if isDistributorPlp}
          <DistributorHeader {distributor} {authStatus} />
        {/if}
      </div>
    </div>
  </div>

  {#if isDistributorPlp && hideAllDistributorInfo && authStatus != "valid"}
    <svelte:component this={authService?.plpCtaComponent} {authStatus} {authService} {mobileMode} />
  {:else}
    <ProductLinesContainer
      bind:productIndexBannersRes
      bind:shoppableUnitRes
      {mobileMode}
      {Cart}
      {stateParams}
      {discoveryPanelRes}
      includeExternalAds={true}
      dedupeOrganicResultsFromAds={false}
    />
  {/if}
</PageWrapper>
